import { useCallback } from 'react';

export function useTranslationFileOperations() {
  const handleDownload = useCallback((locale: string, content: Record<string, unknown>) => {
    const jsonString = JSON.stringify(content, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${locale}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, []);

  return {
    handleDownload,
  };
}
